import _ from 'lodash';
import { HasNameParts } from '../types';

export default function flattenDriverObject(drivers: HasNameParts[]) {
  const driverList: string[] = [];
  _.forEach(drivers, driver => {
    if (driver && driver.firstName && driver.lastName) {
      driverList.push(`${driver.firstName} ${driver.lastName}`);
    }
  });
  return driverList;
}

export function driverFullName(driver: HasNameParts) {
  return driver && driver.firstName && driver.lastName
    ? `${driver.firstName} ${driver.lastName}`
    : '';
}
